export const SIGNUP_BEGIN = 'signup_begin';
export const SIGNUP_SUCCESS = 'signup_success';
export const SIGNUP_ERROR = 'signup_error';
export const SIGNUP_RESET = 'signup_reset';